/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TasksControllerUpdateMutationRequest, TasksControllerUpdateMutationResponse, TasksControllerUpdatePathParams, TasksControllerUpdate400, TasksControllerUpdate401, TasksControllerUpdate403, TasksControllerUpdate404 } from "../../models/tasksController/TasksControllerUpdate";

function getTasksControllerUpdateUrl(id: TasksControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/tasks/${id}` as const }  
  return res
}

/**
 * @summary Update a task
 * {@link /api/v1/tasks/:id}
 */
export async function tasksControllerUpdate(id: TasksControllerUpdatePathParams["id"], data?: TasksControllerUpdateMutationRequest, config: Partial<RequestConfig<TasksControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TasksControllerUpdateMutationResponse, ResponseErrorConfig<TasksControllerUpdate400 | TasksControllerUpdate401 | TasksControllerUpdate403 | TasksControllerUpdate404>, TasksControllerUpdateMutationRequest>({ method : "PATCH", url : getTasksControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}